import type { RecipientGroupType } from '@api';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Text, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type GroupLabelCellPropsType = Pick<
  RecipientGroupType,
  'label' | 'onlyCcRecipientSet'
>;

export const GroupLabelCell: React.FC<GroupLabelCellPropsType> = ({
  label,
  onlyCcRecipientSet,
}) => {
  const { t } = useTranslation();

  return (
    <Group gap="xs" wrap="nowrap">
      <Text size="sm">{label}</Text>
      {onlyCcRecipientSet && (
        <Tooltip label={t('REPORTS.RECIPIENT_GROUPS.ONLY_CC')}>
          <FontAwesomeIcon
            icon={faTriangleExclamation}
            color="var(--mantine-color-red-6)"
            aria-label={t('REPORTS.RECIPIENT_GROUPS.ONLY_CC')}
          />
        </Tooltip>
      )}
    </Group>
  );
};
